import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import PublicServiceReceptionExpenses from '@/types/table/publicServiceReceptionExpenses';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface PublicServiceReceptionExpensesData extends PublicServiceReceptionExpenses {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class PublicServiceReceptionExpensesController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<PublicServiceReceptionExpensesData>>(API_CONTEXT + '/app/publicServiceReceptionExpenses/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<PublicServiceReceptionExpensesData>(API_CONTEXT + '/app/publicServiceReceptionExpenses/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/publicServiceReceptionExpenses/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/publicServiceReceptionExpenses/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/publicServiceReceptionExpenses/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/publicServiceReceptionExpenses/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/publicServiceReceptionExpenses/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/publicServiceReceptionExpenses/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/publicServiceReceptionExpenses/deleteBatch', params, httpOptions);
  }
}
